import { render, staticRenderFns } from "./ShareIdeas.vue?vue&type=template&id=1b44d87d&"
import script from "./ShareIdeas.vue?vue&type=script&lang=js&"
export * from "./ShareIdeas.vue?vue&type=script&lang=js&"
import style0 from "./ShareIdeas.vue?vue&type=style&index=0&id=1b44d87d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports